
export const PHONE_EMAIL_STORAGE_NAME = 'PHONE_EMAIL_STORAGE_NAME'

